import { point_of_sale_video_id } from 'src/consts/resource';

const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale.png`,
      title: 'Point of Sale System',
      description: `The next-generation all-in-one POS that can save you >$8,000/mo in labor costs and grow your business by 25%.`,
      youtubeVideoId: point_of_sale_video_id,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale.png`,
      title: '智能餐饮管理系统',
      description: '专为亚洲餐厅打造的餐饮管理系统，已帮助上千家餐厅实现降本增效',
      youtubeVideoId: point_of_sale_video_id,
    },
  },
  advances: {
    en: {
      title: `Expand Your Business with Chowbus POS`,
      subTitle: `Our powerful cloud-based software brings together order management, sales tracking, and seamless payment processing, specially designed for the restaurant industry by experts who understand your needs.`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_1.png`,
          imageAlt: 'Order & Table Management',
          title: 'Order & Table Management',
          description: 'Manage customer orders, add or edit items to open orders, and track order to fulfillment.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_2.png`,
          imageAlt: 'Reporting & Analytics',
          title: 'Reporting & Analytics',
          description:
            'Get access to real-time sales, items sold, average order size, payment types; earnings reports; payout reports; and cash drawer reports to help you make better decisions for your business.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_3.png`,
          imageAlt: 'Menu & Team Management',
          title: 'Menu & Team Management',
          description:
            'Create and adjust employee schedules; clock in and out; Track employee working hours and productivity',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_4.png`,
          imageAlt: 'Built Your Way to Reward and Engage Customers',
          title: 'Payment Processing',
          description:
            'Simple and competitive rates on all transactions. No hidden fees, no additional markups, and no extra charges.',
        },
      ],
    },
    zh: {
      title: `借助Chowbus POS实现商业成功`,
      subTitle: `Chowbus POS是专为餐厅定制并基于云端的智能餐饮管理系统。通过强大的POS管理系统，您可以轻松管理餐厅订单、员工及支付收单，纵享基于云端的畅快体验。`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_1.png`,
          imageAlt: '订单管理',
          title: '订单管理',
          description: '轻松管理包括堂食、外卖、官网在内的所有菜单和订单',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_2.png`,
          imageAlt: '报表数据分析',
          title: '报表数据分析',
          description: '基于云端的POS系统为您提供实时报表数据，助力您更好地决策',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_3.png`,
          imageAlt: '团队管理',
          title: '团队管理',
          description: '提供排班、打卡等功能，有效追踪员工工作时长及效率',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_feature_4.png`,
          imageAlt: '支付收单',
          title: '支付收单',
          description: '拥有市场上最低的费率，且无其他费用产生',
        },
      ],
    },
  },

  features: {
    en: {
      title: 'Every POS Feature You Need',
      desc: 'We keep it simple (yet powerful!) with our easy-to-use product design and interfaces.',
      items: [
        {
          layout: 'column',
          direction: 'normal',
          title: 'Order & Table Management',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_1.png`,
          items: [
            {
              desc: 'All-in-one interface to manage all orders, sales, and payments.',
            },
            {
              desc: `Easily view all orders from dine-in, take-out, delivery, and your website all in one place!`,
            },
            {
              desc: 'Combine checks from different tables, split bills, or combine bills with a few clicks.',
            },
          ],
        },
        {
          layout: 'column',
          direction: 'reverse',
          title: 'Reporting & Analytics',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_2.png`,

          items: [
            {
              desc: 'Speed up employee onboarding, simplify payroll, and ensure your team is paid on time.',
            },
            {
              desc: `Easily manage your team across timesheets and schedules.`,
            },
            {
              desc: `Automate tip distribution and manage the share by sales category or by total tips`,
            },
            {
              desc: `Customized reports for restaurant performance and sales reports, accessible from any device.`,
            },
          ],
        },
        {
          layout: 'column',
          direction: 'normal',
          title: 'Menu & Team Management',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_3.png`,
          items: [
            {
              desc: 'Make menu updates from any terminal at your restaurant, at anytime!',
            },
            {
              desc: `Easily manage menu availability with item countdowns for dine-in, take-out, delivery, and website orders.`,
            },
          ],
        },
        {
          layout: 'column',
          direction: 'reverse',
          title: 'Payment Processing',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_4.png`,
          items: [
            {
              desc: 'Seamless and secure payment processing for debit, credit, cash, gift cards, Wechat Pay, Apple Pay, and more!',
            },
            {
              desc: `Year round 24/7 customer care for your restaurant needs and POS questions.`,
            },
            {
              desc: `Capture guest contact info for future loyalty programs and marketing campaigns to drive repeat business!`,
            },
          ],
        },
      ],
    },
    zh: {
      title: '提供最全面的智能餐饮管理系统',
      desc: '我们有更简洁、时尚的操作界面，基于云端的畅快体验，以及更丰富的产品选择。',
      items: [
        {
          layout: 'column',
          direction: 'normal',
          title: '订单管理',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_1.png`,
          items: [
            {
              desc: '在一个界面上管理所有订单信息，包括负责服务员、销售金额、小费情况等',
            },
            {
              desc: `在一个系统内轻松管理包括堂食、外卖、官网在内的所有菜单和订单`,
            },
            {
              desc: '仅需几步点击，即可操作分桌或合并结账',
            },
          ],
        },
        {
          layout: 'column',
          direction: 'reverse',
          title: '报表数据分析',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_2.png`,

          items: [
            {
              desc: '直观的数据看板让您对营业额、小费、费用等核心经营数据一目了然',
            },
            {
              desc: `详细的数据报表可以满足不同场景的分析需求`,
            },
            {
              desc: `清晰的数据图表让您快速获取订单分布、最受欢迎的菜品、类目等信息`,
            },
          ],
        },
        {
          layout: 'column',
          direction: 'normal',
          title: '团队管理',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_3.png`,
          items: [
            {
              desc: '轻松管理员工的排班表、出勤情况，并统计各自收入、小费、销售业绩等',
            },
            {
              desc: `根据餐厅需求，灵活配置小费分配方案`,
            },
            {
              desc: `可以通过角色设置员工在POS系统内的不同权限`,
            },
          ],
        },
        {
          layout: 'column',
          direction: 'reverse',
          title: '支付收单',
          cover: `${process.env.ASSETS_PREFIX}/products/products_point_of_sale_advance_4.png`,
          items: [
            {
              desc: '支持包括信用卡、借记卡、现金、礼品卡、微信支付、手机钱包在内的多种支付方式',
            },
            {
              desc: `顾客可自由选择分单支付、分菜品支付、合并账单支付`,
            },
            {
              desc: `可以设置首单折扣、消费返现等多种促销形式，以及会员充值、礼品卡、充值返现等多种会员方案`,
            },
          ],
        },
      ],
    },
  },

  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-machimachi.jpeg`,
      productLine: 'Loyalty',
      desc: {
        zh: `“自从我们在纽约中城开了第一家店之后，就一直使用Chowbus POS和他们的智能⾃助点餐机。之后我们还加入了餐厅专属会员系统。客人在智能⾃助点餐机上点完餐后，系统就会自动弹出弹窗，引导客人注册成餐厅会员。这个系统在智能⾃助点餐机的基础上，自动地将新顾客转化成忠实的回头客。用了一段时间后，我们的客单价提高了18%，餐厅利润提高了，用户关系也变得更加牢固了。我们对这个效果非常满意！”`,
        en: `Mochinut: "We've started using Chowbus One when we opened and recently added the Chowbus Kiosk, 40% of our dine-in customers utilize the Kiosk because it has a large display with plenty of pictures and is extremely user friendly. Over a third of our customers who use our Kiosk become our members, which helps us build our membership base. Historically, one of our biggest pain points is that sometimes we have a long queue of customers waiting to place their orders and thankfully Chowbus Kiosk has helped us solve this issue."`,
      },
      restaurantName: { zh: 'Machi Machi', en: 'Machi Machi' },
      location: { zh: '纽约', en: 'New York, NY' },
      link: '/business-types/boba-tea-dessert/machi-machi',
    },
  ],
};

export default SectionContent;
